import "./index.less";
import React, { useEffect, useMemo } from "react";
import ShopSelect from "./ShopSelect";
import OrderTable from "./OrderTable";
import BottomOperationBar from "./BottomOperationBar";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { getIsSupplierByShopType } from "@/utils/dropShipping";
import ShopExpiredAlert from "./ShopExpiredAlert";
import AbnormalAlert from "./AbnormalAlert";
import useProcessingShop from "../hooks/useProcessingShop";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";
import { useOrderManagementStore } from "../store/OrderManagementStore";
import ShopType from "@/enum/ShopType";
import Coupon from "./OrderTable/Coupon";
import PlatformNotification from "./OrderTable/PlatformNotification";
import { useShowDouDianPreShipDialog } from "./DouDianPreShipDIalog";
import { useTaoBaoShipBySfJcDialog } from "./TaoBaoShipBySfJcDialog";

interface OrderManagementProps {
    shopId?: number;

    tab?: OrderTab;
}

const OrderManagement: React.FC<OrderManagementProps> = function (props) {
    const { tab } = props;

    const orderManagementStore = useOrderManagementStore();

    const globalStore = useGlobalStore();
    const { shopId, shops } = useProcessingShop(props.shopId);

    const shop = globalStore.shopMapping.get(shopId);

    useEffect(() => {
        if (!shop) return;

        // 如果是手工店铺,表格有用到发货人信息,需要确保加载一次发货地址
        if (shop.type === ShopType.MANUAL || shop.type === ShopType.INDEPENDENT_MANUAL) {
            globalStore.waybillPrintStore.ensureShippingAddresses();
        }

        return () => {
            globalStore.waybillPrintStore.clear();
            globalStore.ewaybillAccountStore.clear();
            globalStore.packListPrintStore.clear();
        };
    }, [shop?.id]);

    useEffect(() => {
        if (!shop) return;

        globalStore.getShopSetting([shop.id]);
    }, [shop?.id]);

    useEffect(() => {
        orderManagementStore.instantShipStore.reset();

        if (shop?.type === ShopType.DOUDIAN) {
            orderManagementStore.instantShipStore.loadCurrentTask(shop.id);
        }

        return () => {
            orderManagementStore.instantShipStore.reset();
        };
    }, [shop?.id, shop?.type]);

    const couponCacheName = useMemo(() => {
        if (shop?.type === ShopType.ALIBABA) return "2025-03-alibaba-seller-festival";

        return "";
    }, [shop?.type]);

    useShowDouDianPreShipDialog(shop?.id);

    useTaoBaoShipBySfJcDialog(shop?.id);
    useEffect(() => {
        // 淘宝加顺丰任务需要模板信息，提前加载出来，这里后续任务下线后可以移除
        globalStore.waybillPrintStore.ensureWaybillTemplates();
    }, []);

    if (!shops.length) {
        return (
            <div className="order-management">
                <ShopSelect />
                <div className="order-main" />
            </div>
        );
    }

    if (!shop) {
        return (
            <div className="order-management">
                <ShopSelect shopId={shopId} />
                <div className="order-main tc">未找到该店铺</div>
            </div>
        );
    }

    const isSupplierShop = getIsSupplierByShopType(shop.type);

    return (
        <div className="order-management">
            <ShopSelect shopId={shopId} />
            <div className="order-main">
                {/* {shop?.type === ShopType.JD ? <JdPremiumRenewCoupon shop={shop} /> : null} */}
                <Coupon shop={shop} cacheName={couponCacheName}></Coupon>

                {orderManagementStore?.orderListCount?.hasAbnormalOrders ? (
                    <AbnormalAlert shopId={shop.id} tab={tab} />
                ) : null}

                <ShopExpiredAlert shopId={shop.id} />

                <PlatformNotification shop={shop} tab={tab} />

                <OrderTable shop={shop} tab={tab} isSupplierShop={isSupplierShop} />

                <BottomOperationBar shop={shop} tab={tab} isSupplierShop={isSupplierShop} />
            </div>
        </div>
    );
};

export default observer(OrderManagement);
